module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAABHNCSVQICAgIfAhkiAAAAOZJREFUSEvtljFOAkEYRr/vJ1AgsdDdgoJYeQ5ILCTxFNaex12gIeEKEJwJCUfAKxhbSo2RlZ3PwsRoQrmzDcwB3su8mfwzTFy2IG1IoIGIS8A+SI9M/eidwFlE1y9a0jMvXfZA2i2FZkypTMVXwIwxJYfYJ2HlxY8gaduNu23TgGKr8n7/gPrclsUTE5e/GHkVV/ZDl7Ri4vNXA3t1CAO05vl8dN1qhr7IqJPGDLuPIiyP4JbWcXZ/HaeklRfnhcvuG+CdEPcBJm23L8spU5+/EexUvpUDQEEbpj7zgN3U8IkqAzT5Bp3vR7/XgmPGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/nav.png
// module id = 897T
// module chunks = 32